import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestError } from '@/app/common/types_and_interfaces.ts'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import {
  removePurseFunds,
  RemovePurseFundsParams,
} from '@/queries/program_purses/requests.ts'

export const useRemovePurseFunds = (
  options?: UseMutationOptions<unknown, RequestError, RemovePurseFundsParams>
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: removePurseFunds,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSE_DETAILS(
          String(variables.purseId),
          variables.programId
        ),
      })
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSES(variables.programId),
      })
      queryClient.invalidateQueries({
        queryKey: ['TRANSACTION_LOGS', variables.programId, variables.purseId],
      })

      options?.onSuccess?.(data, variables, context)
    },
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}
